import { render } from "./RhTabs.vue?vue&type=template&id=4f865efc&scoped=true&ts=true"
import script from "./RhTabs.vue?vue&type=script&lang=ts"
export * from "./RhTabs.vue?vue&type=script&lang=ts"

import "./RhTabs.vue?vue&type=style&index=0&id=4f865efc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f865efc"]])

export default __exports__